<template>
  <div class="page-container vip-whitelist-page">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">VIP管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>VIP白名单用户</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="page-content" shadow="never">
      <el-form :inline="true" :model="query" size="small" class="query-form">
        <el-form-item label="用户UID">
          <el-input v-model.trim="query.userUid" clearable placeholder="请输入用户UID" />
        </el-form-item>
        <el-form-item label="合伙人UID">
          <el-input v-model.trim="query.topPartnerUid" clearable placeholder="请输入合伙人UID" />
        </el-form-item>
        <el-form-item label="VIP等级">
          <el-select v-model="query.vipLevel" clearable placeholder="全部">
            <el-option v-for="item in vipLevels" :key="item.code" :label="item.label" :value="Number(item.code)" />
          </el-select>
        </el-form-item>
        <el-form-item label="配置类型">
          <el-select v-model="query.configType" clearable placeholder="全部">
            <el-option v-for="item in configTypes" :key="item.code" :label="item.label" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="query.timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="timestamp"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <div class="toolbar">
        <el-button v-if="canAdd" type="primary" size="small" @click="openCreate">新增</el-button>
      </div>

      <el-table :data="rows" border size="small" style="width: 100%">
        <el-table-column prop="userUid" label="用户UID" width="120" align="center" />
        <el-table-column prop="actualUserTypeName" label="用户类型" width="120" align="center" />
        <el-table-column label="合伙人UID" width="130" align="center">
          <template slot-scope="scope">{{ scope.row.topPartnerUid || '--' }}</template>
        </el-table-column>
        <el-table-column label="VIP等级" width="100" align="center">
          <template slot-scope="scope">VIP{{ scope.row.vipLevel || 0 }}</template>
        </el-table-column>
        <el-table-column prop="configTypeName" label="配置类型" width="120" align="center" />
        <el-table-column label="保级周期" width="120" align="center">
          <template slot-scope="scope">{{ scope.row.retentionCycleTypeName || '--' }}</template>
        </el-table-column>
        <el-table-column label="宽限天数" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.retentionGraceDays === null || scope.row.retentionGraceDays === undefined ? '--' : scope.row.retentionGraceDays }}</template>
        </el-table-column>
        <el-table-column prop="userTypeName" label="添加类型" width="140" align="center" />
        <el-table-column label="备注" min-width="160" align="center">
          <template slot-scope="scope">{{ scope.row.remark || '--' }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="170" align="center">
          <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="创建人" width="120" align="center">
          <template slot-scope="scope">{{ scope.row.createBy || '--' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="90" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button v-if="canDelete" type="text" size="small" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="page"
        :page-sizes="[10, 20, 50]"
        @size-change="onSizeChange"
        @current-change="fetchList"
      />
    </el-card>

    <el-dialog title="新增" :visible.sync="dialogVisible" width="720px" custom-class="vip-whitelist-dialog" @close="resetForm">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="small">
        <el-form-item label="配置类型" prop="configType">
          <el-radio-group v-model="form.configType" @change="onConfigTypeChange">
            <el-radio v-for="item in configTypes" :key="item.code" :label="item.code">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="添加类型" prop="userType">
          <el-select v-model="form.userType" placeholder="请选择添加类型">
            <el-option v-for="item in userTypes" :key="item.code" :label="item.label" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="UID" prop="userUid">
          <el-input v-model.trim="form.userUid" placeholder="请输入UID" />
        </el-form-item>
        <el-form-item label="VIP等级" prop="vipLevel">
          <el-select v-model="form.vipLevel" placeholder="请选择VIP等级">
            <el-option v-for="item in vipLevels" :key="item.code" :label="item.label" :value="Number(item.code)" />
          </el-select>
        </el-form-item>
        <template v-if="form.configType === 'FIXED_LEVEL'">
          <el-form-item label="保级周期" prop="retentionCycleType">
            <el-select v-model="form.retentionCycleType" placeholder="请选择保级周期" disabled>
              <el-option v-for="item in retentionCycleTypes" :key="item.code" :label="item.label" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item label="宽限天数" prop="retentionGraceDays">
            <el-input
              v-model.trim="form.retentionGraceDays"
              maxlength="3"
              placeholder="请输入0-999的整数"
              @input="onRetentionGraceDaysInput"
            />
          </el-form-item>
        </template>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saving" @click="submit">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { hasPerm } from 'common/permission';
import api from './api';

function emptyQuery() {
  return {
    userUid: '',
    topPartnerUid: '',
    vipLevel: '',
    configType: '',
    timeRange: [],
  };
}

function emptyForm() {
  return {
    configType: 'FIXED_LEVEL',
    userType: '',
    userUid: '',
    vipLevel: '',
    retentionCycleType: 'DAILY',
    retentionGraceDays: '',
    remark: '',
  };
}

export default {
  name: 'VipWhitelistPage',
  data() {
    const uidValidator = (rule, value, callback) => {
      if (!/^[1-9]\d*$/.test(String(value || ''))) {
        callback(new Error('请输入正确UID'));
        return;
      }
      callback();
    };
    const graceValidator = (rule, value, callback) => {
      if (this.form.configType !== 'FIXED_LEVEL') {
        callback();
        return;
      }
      const text = value === null || value === undefined ? '' : String(value);
      if (!/^\d{1,3}$/.test(text)) {
        callback(new Error('请输入0-999的整数'));
        return;
      }
      callback();
    };
    return {
      query: emptyQuery(),
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      vipLevels: [],
      configTypes: [],
      userTypes: [],
      retentionCycleTypes: [],
      dialogVisible: false,
      saving: false,
      form: emptyForm(),
      rules: {
        configType: [{ required: true, message: '请选择配置类型', trigger: 'change' }],
        userType: [{ required: true, message: '请选择添加类型', trigger: 'change' }],
        userUid: [{ required: true, validator: uidValidator, trigger: 'blur' }],
        vipLevel: [{ required: true, message: '请选择VIP等级', trigger: 'change' }],
        retentionCycleType: [{ required: true, message: '请选择保级周期', trigger: 'change' }],
        retentionGraceDays: [{ required: true, validator: graceValidator, trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapState(['userInfo']),
    canAdd() {
      return hasPerm(this.userInfo || {}, 'tenant:vip_whitelist:add');
    },
    canDelete() {
      return hasPerm(this.userInfo || {}, 'tenant:vip_whitelist:delete');
    },
  },
  created() {
    this.loadEnums();
    this.fetchList();
  },
  methods: {
    async loadEnums() {
      const res = await api.enums();
      const data = (res && res.data) || {};
      this.vipLevels = data.vipLevels || [];
      this.configTypes = data.configTypes || [];
      this.userTypes = data.userTypes || [];
      this.retentionCycleTypes = data.retentionCycleTypes || [];
      if (this.retentionCycleTypes.length) {
        this.form.retentionCycleType = this.retentionCycleTypes[0].code;
      }
    },
    async fetchList() {
      const params = {
        page: this.page,
        size: this.pageSize,
        userUid: this.query.userUid,
        topPartnerUid: this.query.topPartnerUid,
        vipLevel: this.query.vipLevel,
        configType: this.query.configType,
      };
      if (this.query.timeRange && this.query.timeRange.length === 2) {
        params.startTime = this.query.timeRange[0];
        params.endTime = this.query.timeRange[1];
      }
      const res = await api.page(params);
      const data = (res && res.data) || {};
      this.rows = data.items || [];
      this.total = data.total || 0;
    },
    search() {
      this.page = 1;
      this.fetchList();
    },
    resetQuery() {
      this.query = emptyQuery();
      this.page = 1;
      this.fetchList();
    },
    onSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.fetchList();
    },
    openCreate() {
      this.form = emptyForm();
      if (this.retentionCycleTypes.length) {
        this.form.retentionCycleType = this.retentionCycleTypes[0].code;
      }
      this.dialogVisible = true;
    },
    onConfigTypeChange() {
      if (this.form.configType !== 'FIXED_LEVEL') {
        this.form.retentionCycleType = '';
        this.form.retentionGraceDays = '';
      } else if (this.retentionCycleTypes.length) {
        this.form.retentionCycleType = this.retentionCycleTypes[0].code;
      }
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    onRetentionGraceDaysInput(value) {
      const text = value === null || value === undefined ? '' : String(value);
      this.form.retentionGraceDays = text.replace(/\D/g, '').slice(0, 3);
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.saving = true;
        try {
          const payload = {
            ...this.form,
            userUid: Number(this.form.userUid),
            vipLevel: Number(this.form.vipLevel),
            retentionGraceDays: this.form.configType === 'FIXED_LEVEL' ? Number(this.form.retentionGraceDays) : null,
            retentionCycleType: this.form.configType === 'FIXED_LEVEL' ? this.form.retentionCycleType : null,
          };
          await api.save(payload);
          this.$message.success('新增成功');
          this.dialogVisible = false;
          this.fetchList();
        } finally {
          this.saving = false;
        }
      });
    },
    remove(row) {
      this.$confirm('删除后将无法恢复，请谨慎操作。', '确认删除该条白名单记录吗？', {
        type: 'warning',
        confirmButtonText: '确认',
        cancelButtonText: '取消',
      })
        .then(async () => {
          await api.delete(row.id);
          this.$message.success('删除成功');
          this.fetchList();
        })
        .catch(() => {});
    },
    resetForm() {
      this.form = emptyForm();
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    formatTime(value) {
      if (!value) return '--';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      const pad = (num) => String(num).padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
  },
};
</script>

<style scoped>
.vip-whitelist-page .page-content {
  margin-top: 16px;
}
.query-form {
  margin-bottom: 12px;
}
.toolbar {
  margin-bottom: 12px;
  text-align: right;
}
.pager {
  margin-top: 16px;
  text-align: right;
}
/deep/ .vip-whitelist-dialog .el-dialog__body {
  padding: 28px 64px 18px;
}
/deep/ .vip-whitelist-dialog .el-select {
  width: 100%;
}
/deep/ .vip-whitelist-dialog .el-radio {
  margin-right: 42px;
}
</style>
